export default __webpack_public_path__ + "static/media/teams-jens.b986c40a.jpg";